module.exports = __webpack_public_path__ + "img/businessCoreImg.5926a58d.png";